// extracted by mini-css-extract-plugin
module.exports = {"textarea":"TemplateSpec_textarea__3XhlU","manifest-url":"TemplateSpec_manifest-url__11nMX","row":"TemplateSpec_row__ee4iW"};